// extracted by mini-css-extract-plugin
export default {"wrapper":"PageLoading_wrapper__3tLIl"};